import React from 'react';
import envConfig from '../../../config/env';

/**
 * 20210126 自動職缺零筆 也不顯示
 */
class CompanyJobs extends React.Component {

    constructor(props){
        super(props);
        this.state={};
        // console.log('CompanyJobs-4')
    }

    componentDidMount(){
        const cid = this.props.match.params.cid;
        this.props.getPositionList(cid, this.props.themeNum);
        this.props.getPositionGrpList(cid, this.props.themeNum);
        this.props.getkind00(cid);       
    }  

    render(){
        const { positionGrpData } = this.props.positionGrpReducer;
		const { positionData } = this.props.positionReducer;
        const { kind00Data } = this.props.kind00Reducer;
        let isAutoPosition=0;//add 20201207
        const limitCount=envConfig.PositionCount;
        if(positionGrpData && positionGrpData.length > 0){
            positionGrpData.forEach( element  => {
            isAutoPosition=element.position_IsAuto;
            })     
        }
       
        let positionURL2 = "https://www.1111.com.tw/job/";
               
        let owlLists = [];
        if(isAutoPosition===0){
            Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                                        
                owlLists.push(
                        <div key={index} className="service-block-three">
                            <div className="inner-box">
                                <div className="icon-box"><i className="flaticon-digital-marketing"></i></div>
                                <h4><a href={positionURL}>{element.position_name}</a></h4>
                                <div className="text benefit-hide-text"><p>{element.position_workCity}</p></div>
                                <div className="text benefit-hide-text"><p>{element.position_salary}</p></div>
                                <div className="text benefit-hide-text"><p>{element.position_experience} │ {element.position_grade}</p></div>
                                <div className="btn-box p-t-20"><a className="btn-style-three" target="_blank" rel="noopener noreferrer" href={positionURL}>我要應徵</a></div>
                            </div>
                        </div>
                )                    
            })
          
        } 
        else if(isAutoPosition===1){
            //console.log(props.kind00Data);
            //console.log('props.kind00Data type:'+typeof(props.kind00Data));              
            
            Array.isArray(kind00Data) && kind00Data.forEach((element, index) => {
                let positionURL = positionURL2+ element.eNo + "/";
                if(index < limitCount){
                    owlLists.push(
                        <div key={index} className="service-block-three">
                                <div className="inner-box">
                                    <div className="icon-box"><i className="flaticon-digital-marketing"></i></div>
                                    <h4><a href={positionURL}>{element.Position}</a></h4>
                                    <div className="text benefit-hide-text"><p>{element.WorkCity}</p></div>
                                    <div className="text benefit-hide-text"><p>{element.Salary}</p></div>
                                    <div className="text benefit-hide-text"><p>{element.Experience===null?"":element.Experience} │ {element.Grade}</p></div>
                                    <div className="btn-box p-t-20"><a className="btn-style-three" target="_blank" rel="noopener noreferrer" href={positionURL}>我要應徵</a></div>
                                </div>
                            </div>)
                }
            })
          
        }

        
        return (
            <section id="jobs" className="service-style-three gray-bg centred" 
                     style={ ((isAutoPosition===0 && positionData.length <= 0) 
                     || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
                     ) ? {display: 'none'} :{}  }>
            <style>
              { ((isAutoPosition===0 && positionData.length <= 0) 
              || (isAutoPosition===1 && (kind00Data.length <= 0 || (kind00Data.length===1 && kind00Data[0].oNo===0)))
              ) && `.job-display {display:none !important;}`}
            </style>     
            <div className="anim-icon">
                    <div className="icon icon-1"></div>
                    <div className="icon icon-2 rotate-me"></div>
                    <div className="icon icon-3 float-bob-y"></div>
                    <div className="icon icon-4 float-bob-x"></div>
                    <div className="icon icon-5"></div>
                    <div className="icon icon-6 rotate-me"></div>
                </div>
                <div className="container">
                    <div className="sec-title">
                        <h4>Jobs</h4>
                        <h1>熱門職缺</h1>
                    </div>          
                    {/* owl-nav-none 2021-02-17拿掉 */}
                     <div className="three-column-carousel owl-carousel owl-theme">{owlLists}
                    
                       {/* 因為有多一段自動職缺 所以這一塊東西一到return上面去
                        {Array.isArray(positionData) && positionData.filter( data => data.position_group === "1").map((element, index) => {
									let positionURL = "https://www.1111.com.tw/job/"+ element.eNo + "/";
															
									return(

                                            <div key={index} className="service-block-three">
                                                <div className="inner-box">
                                                    <div className="icon-box"><i className="flaticon-digital-marketing"></i></div>
                                                    <h4><a href={positionURL}>{element.position_name}</a></h4>
                                                    <div className="text benefit-hide-text"><p>{element.position_workCity}</p></div>
                                                    <div className="text benefit-hide-text"><p>{element.position_salary}</p></div>
                                                    <div className="text benefit-hide-text"><p>{element.position_experience} │ {element.position_grade}</p></div>
                                                    <div className="btn-box p-t-20"><a className="btn-style-three" target="_blank" rel="noopener noreferrer" href={positionURL}>我要應徵</a></div>
                                                </div>
                                            </div>

                                         )

						})} */}
                 </div>
                
                </div>
            </section>
        )

    }
}

export default CompanyJobs;